import moment from "moment";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import ProfileCard from "../../../components/ContactInfo/ProfileCard";
import { constants } from "../../../constants/common";

const PolicyCategory = () => {
  const policyCategoryConfig: MasterConfigs = {
    api: () => '/policy-category',
    title: 'Policy Category',
    isActionTab: true,
    modalTitle: (action) => `${action}  Category`,
    getColumns: () => {
      return [
        {
          title: 'Category Name',
          dataIndex: 'name',
          key: 'name',
          isSearch: true,
        },
        {
          title: 'Created By',
          dataIndex: 'addedBy',
          key: 'addedBy',
          render: (item) => <ProfileCard
            size={30}
            name={constants.GET_FULL_NAME(item)}
            avatarUrl={item?.avatar ? process.env.FILE_URL + item?.avatar : ''}
            role={item?.employeeId}
          />
        },
        {
          title: 'Created At',
          dataIndex: 'createdAt',
          key: 'createdAt',
          isSearch: true,
          render: (text) => {
            return moment(text).format('DD MMM YYYY');
          },
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Category Name',
          name: 'name',
          type: 'text',
          rules: [{ required: true, message: 'Please enter category name' }]
        }
      ];
    },
    combo: [
    ],
    getData: () => ({}),
    actions: [
      { name: 'Add Category', actionType: 'Add' }
    ],
  };

  return <div className="-mt-6">
    <MasterComponent config={policyCategoryConfig} isModal={true} />
  </div>
}


export default PolicyCategory;